module.exports = __webpack_public_path__ + "static/25import-79405f00929e90ba52636fe787956111.png";